module.exports = __webpack_public_path__ + "img/Img3@2x.6c42bdfd.jpg";